export const columns = [
  {
    columnId: 1,
    name: '订单操作',
    key: 'handle',
    minWidth: '105',
  },
  {
    columnId: 2,
    name: '发票',
    key: 'invoiceUrl',
    minWidth: 150,
  },
  {
    columnId: 3,
    name: '装箱批次号',
    key: 'containerBatchNo',
    minWidth: 120,
  },
  {
    columnId: 4,
    name: '创建日期',
    key: 'createTime',
    minWidth: 90,
  },
  {
    columnId: 5,
    name: '客户名',
    key: 'realName',
    minWidth: 80,
  },
  {
    columnId: 6,
    name: '客户ID',
    key: 'userName',
    minWidth: 100,
  },
  {
    columnId: 7,
    name: '状态',
    key: 'containerState',
    minWidth: 70,
  },
  {
    columnId: 8,
    name: '发送日',
    key: 'sendTime',
    minWidth: 160,
  },
  {
    columnId: 9,
    name: '箱数',
    key: 'containerBoxesCount',
    minWidth: 40,
  },
  {
    columnId: 22,
    name: '重量',
    key: 'realWeight',
    minWidth: 120
  },
  {
    columnId: 23,
    name: '实际关税',
    key: 'actualCustomsDuty',
    minWidth: 200
  },
  {
    columnId: 10,
    name: '国际物流',
    key: 'logisticeCompany',
    minWidth: 150,
  },
  {
    columnId: 11,
    name: '收件信息',
    key: 'recipientName',
    minWidth: 250,
  },
  // {
  //     columnId: 11,
  //     name: "收件人",
  //     key: "recipientName",
  //     width: 80,
  // },
  // {
  //     columnId: 12,
  //     name: "收件人邮编",
  //     key: "zipCode",
  //     width: 100,
  // },
  // {
  //     columnId: 13,
  //     name: "收件地址",
  //     key: "deliveryAddress",
  //     width: 250,
  // },
  {
    columnId: 14,
    name: '线路',
    key: 'route',
    minWidth: 50,
  },
  {
    columnId: 15,
    name: '备注',
    key: 'comments',
    minWidth: 150,
  },
  {
    columnId: 16,
    name: '进口商信息',
    key: 'senderAddress',
    minWidth: 250,
  },
  {
    columnId: 17,
    name: '工作签',
    key: 'remark',
    minWidth: 200,
  },
  {
    columnId: 18,
    name: '客户附件',
    key: 'attachment',
    width: '200',
  },
  {
    columnId: 19,
    name: '员工附件',
    key: 'operatorAttachment',
    width: '200',
  },
  {
    columnId: 20,
    name: 'YFF/RSL/FBA/ZOZO',
    key: 'containerOrderType',
    width: 100,
  },
  {
    columnId: 21,
    name: '输入许可书',
    key: 'permitBook',
    width: 150,
  },
  // {
  //   columnId: 30,
  //   name: '客户备注',
  //   key: 'remarkCustomerName',
  //   minWidth: 100,
  // },
  {
    columnId: 31,
    name: '员工备注',
    key: 'employeeRemark',
    minWidth: 100,
  },
]